<ion-list mode="ios" lines="none" class="list-content">
  <!-- * Titulo -->
  <ion-item mode="md" lines="none" color="white" class="item-title">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="ion-text-center mpe-font-weight-600"
    >
      {{ 'Titles.regain-access-account' | translate }}
    </ion-label>
  </ion-item>

  <!-- * Imagen -->
  <ion-item mode="md" lines="none" color="white">
    <ion-img [src]="'Icons.padlock' | translate" class="img-padlock"></ion-img>
  </ion-item>

  <!-- * Contenido -->
  <ion-item mode="md" lines="none" color="white">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="ion-text-center content-text"
    >
      {{ 'Labels.recover-will-register-again' | translate }}
    </ion-label>
  </ion-item>

  <!-- * Botones -->
  <ion-item mode="md" lines="none" color="white" class="item-buttons">
    <ion-button
      class="buttons"
      size="default"
      mode="md"
      color="tpcta"
      fill="clear"
      (click)="onClose(true)"
    >
      <ion-label mode="md" color="tpcta" class="mpe-font-weight-600">
        {{ 'Buttons.continue' | translate }}
      </ion-label>
    </ion-button>

    <ion-button
      class="buttons"
      size="default"
      mode="md"
      color="tpcta"
      (click)="onClose(false)"
    >
      <ion-label mode="md" color="white" class="mpe-font-weight-600">
        {{ 'Buttons.return' | translate }}
      </ion-label>
    </ion-button>
  </ion-item>
</ion-list>
